import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  public toggleMenuMobile() {
    $('.header-menu-list-v2-hidden').toggleClass('hidden');
  }

  public hideMenuMobile() {
    $('.header-menu-list-v2').addClass('hidden-xs');
  }

  public navigateTo(elementId: string) {
    return document.getElementById(elementId).scrollIntoView();
  }

  public navPage() {
    $('.header-menu-list-v2-hidden').addClass('hidden');
  }

}



// WEBPACK FOOTER //
// ./src/app/public/header/header.component.ts